"use strict";

import module from "./module";
import "./projektberichtvorlagen.spec";

export default module;
